var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TouchPad',{attrs:{"shape":_vm.block.shape,"buttons":_vm.block.buttons},on:{"leverchange":function($event){return _vm.UpdatePad($event)},"touchStart":function($event){return _vm.TouchStart($event)},"touchRelease":function($event){return _vm.TouchRelease($event)},"buttonchange":function($event){return _vm.ButtonChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }